import React from "react"
import config from 'react-global-configuration';
import CardStore from "../../stores/CardStore"
import Card from "../../vo/Card"

/*
var getInvoiceState = () => {
  return InvoiceStore.getAll()
}
*/

export default class Book extends React.Component {

  constructor(){
    super()
    this.getToken = this.getToken.bind(this)
    this.onChange = this.onChange.bind(this)
    this.CardStoreChangeHandler = this.CardStoreChangeHandler.bind(this)
    this.TokenChangeHandler = this.TokenChangeHandler.bind(this)
    this.createPayment = this.createPayment.bind(this)
    this.PaymentChangeHandler = this.PaymentChangeHandler.bind(this)
    this.PayErrorHandler = this.PayErrorHandler.bind(this)
    this.state = {
      item:new Card(),
      token:null,
      is_process:false,
      is_paid:false
    }
  }

  componentDidMount(){
      CardStore.addChangeListener(this.CardStoreChangeHandler)
      CardStore.addChangeListener(this.TokenChangeHandler,"change_token")
      CardStore.addChangeListener(this.PaymentChangeHandler,"change_payment")
      CardStore.addChangeListener(this.PayErrorHandler,"error_pay")
  }

  componentWillUnmount(){
    CardStore.removeChangeListener(this.CardStoreChangeHandler)
    CardStore.removeChangeListener(this.TokenChangeHandler,"change_token")
    CardStore.removeChangeListener(this.PaymentChangeHandler,"change_payment")
    CardStore.removeChangeListener(this.PayErrorHandler,"error_pay")
  }

  onChange(e){
    const target = e.target
    this.props.updateForm(target.name, target.value)
  }


  CardStoreChangeHandler(){
    this.setState(
      {
        item:CardStore.getDetail()
      }
    )
  }

  TokenChangeHandler(){
    this.setState(
      {
        token:CardStore.getToken()
      }
    )
  }

  PaymentChangeHandler(){
    this.setState({
      is_paid:true,
      is_process:true
    })
  }

  PayErrorHandler(){
    this.setState({
      is_process:false,
      token:null
    })
  }

  getToken(){
    this.setState({
      message:null
    })
    this.props.getToken(CardStore.getDetail())
  }

  createPayment(){
    
    this.setState({
      is_process:true,
      message:null
    })
    this.props.createPayment()
  }


  render(){
    if(!this.state.item ){
      return null
    }
    var cardHtml = null
    var confirmBTN = null
    var payBTN = null
    var formHTML = null

    if(!this.state.token){
    cardHtml = <section className="card-name"><i class="fab fa-cc-visa"></i> <i class="fab fa-cc-mastercard"></i>

</section>
    formHTML =
      <div className="form-box">

          <div className="form-box-item">
            <label htmlFor="number">カード番号</label>
            <input className="default-input" type="text" value={this.state.item.number} onChange={this.onChange} name="number"/>
          </div>
          <div className="form-box-item">
            <label htmlFor="exp_month">有効期限 (09/20)</label>
            <div className="form-box-item-com">
              <input className="default-input sml" type="text" value={this.state.item.exp_month} onChange={this.onChange} name="exp_month" placeholder="月"/>

              <input className="default-input sml" type="text" value={this.state.item.exp_year} onChange={this.onChange} name="exp_year" placeholder="年" />
            </div>
          </div>
            <div className="form-box-item">
              <label htmlFor="number">CVC番号 (3桁または4桁)</label>
              <input className="default-input sml" type="password" value={this.state.item.cvc} onChange={this.onChange} name="cvc" />
            </div>
        </div>

      confirmBTN = <button className="create-btn" onClick={this.getToken}>カード情報の確認</button>
    }else{
      if(!this.state.is_process){
        payBTN = <div><section><div className="message">カード情報が確認できました。まだ支払いは完了していません。下記のボタンを押して確定させてください。</div></section><section><button className="create-btn" onClick={this.createPayment}>支払いを確定</button></section></div>
      }
    }

    return(
      <div>
        {cardHtml}
        {formHTML}
        <section className="button-box">
          {confirmBTN}
          {payBTN}
        </section>

      </div>

    )
  }
}



// WEBPACK FOOTER //
// ./src/components/parts/Card.js